var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OdometerService } from '../odometer.service';
import * as Odometer from 'odometer';
var BrowserOdometerService = /** @class */ (function (_super) {
    __extends(BrowserOdometerService, _super);
    function BrowserOdometerService(document) {
        var _this = _super.call(this) || this;
        _this.document = document;
        return _this;
    }
    BrowserOdometerService.prototype.init = function (selector, initValue, firstUpdate) {
        var odometer = new Odometer({
            el: this.document.querySelector(selector),
            value: initValue
        });
        odometer.update(firstUpdate);
    };
    return BrowserOdometerService;
}(OdometerService));
export { BrowserOdometerService };
